<!-- Navbar -->
<!-- <div class="navbar navbar-expand-lg navbar-light bg-white shadow p-4 pl-5 bg-body"> -->
<div class="navbar navbar-expand-lg navbar-dark bg-black shadow-sm p-4 pl-5 bg-body" style="background-color: #2e4057;">
  <!-- Vondreii Brand Name -->
  <a class="navbar-brand pr-5 logoFont" routerLink=""><b><span style="color:rgb(218, 65, 103)">t</span>sample</b></a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <!-- Collapsible Links -->
  <div class="collapse navbar-collapse mr-5 pr-5" id="navbarSupportedContent">
    <!-- Empty Link to push others to the right -->
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active">
        <a class="nav-link" href="#"></a>
      </li>
    </ul>
    <ul class="navbar-nav article">
      <!-- Home -->
      <li class="nav-item">
        <a class="nav-link pr-5" href="https://getbootstrap.com/docs/4.1/about/overview/">About Bootstrap</a>
      </li>
    </ul>
  </div>
</div>